<template>
  <div class="upsert-order">
    <KTCodePreview v-bind:title="''">
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <div class="wizard-nav-bg">
            <b-col
              class="py-2 mb-1"
              cols="12"
              style="border-bottom: 0.5px solid #e7e7e7"
            >
              <!-- <i class="fas fa-user-headset"></i> -->
              <b-skeleton-wrapper :loading="!loadingComponent">
                <template #loading>
                  <b-row>
                    <b-col cols="3">
                      <div class="d-flex d-inline">
                        <b-skeleton type="avatar"></b-skeleton>
                        <div class="w-100 pl-2">
                          <b-skeleton width="30%"></b-skeleton>
                          <b-skeleton width="50%"></b-skeleton>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="9" class="text-center align-self-center">
                      <b-skeleton width="70%"></b-skeleton>
                    </b-col>
                  </b-row>
                </template>
                <OrderHeader
                  :entity="orderInfo"
                  :userInfor="userInfor"
                  :action="action"
                  typeHeader="order-upsert"
                  v-if="loadingComponent"
                />
              </b-skeleton-wrapper>
            </b-col>
          </div>
          <div
            class="wizard wizard-4"
            id="kt_wizard_v4_2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <div class="wizard-nav wizard-nav-bg" style="border-radius: 0px">
              <div class="wizard-steps">
                <!-- Step 1: Update Order -->
                <div
                  class="wizard-step mb-0"
                  data-wizard-type="step"
                  data-wizard-state="current"
                >
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Thông tin</div>
                    </div>
                  </div>
                </div>
                <!-- Step 2: Affiliate Information -->
                <div class="wizard-step ml-1 mb-0" data-wizard-type="step">
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Thông tin Affiliate</div>
                    </div>
                  </div>
                </div>
                <!-- Step 3: Order Products Table -->
                <!-- <div class="wizard-step ml-1 mb-0" data-wizard-type="step">
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Sản phẩm</div>
                    </div>
                  </div>
                </div> -->
                <!-- Step 4: Order Transaction -->
                <!-- <div
                  class="wizard-step ml-1 mb-0"
                  data-wizard-type="step"
                  v-if="orderId"
                >
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Bút toán</div>
                    </div>
                  </div>
                </div> -->
                <!-- Step 5: Upload File -->
                <div class="wizard-step ml-1 mb-0" data-wizard-type="step">
                  <div class="wizard-wrapper p-2">
                    <div class="wizard-label">
                      <div class="wizard-title">Đính kèm</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-custom card-shadowless rounded-top-0">
              <div class="card-body p-0">
                <b-row class="py-8">
                  <b-col cols="12">
                    <!-- Step 1: Update Order -->
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                      data-wizard-state="current"
                    >
                      <b-container>
                        <b-row class="col-md-12 mb-1 m-0 p-0" v-if="preOrderId">
                          <b-alert
                            show
                            variant="warning"
                            style="
                              background-color: #fff3db;
                              border-color: #ffecc7;
                            "
                            class="w-100"
                          >
                            <i
                              class="fa fa-exclamation-triangle text-warning"
                            ></i>
                            <strong class="text-dark">
                              Đơn hàng được tạo từ đơn hàng đặt trước:</strong
                            >
                            <b
                              class="text-primary orderCode"
                              @click="linkToPreOrder(preOrderId)"
                              style="cursor: pointer"
                            >
                              {{ preOrderId }}
                            </b>
                          </b-alert>
                        </b-row>
                        <b-row
                          class="col-md-12 mb-1 m-0 p-0"
                          v-if="orderCampainPhase"
                        >
                          <b-alert
                            show
                            variant="warning"
                            style="
                              background-color: #fff3db;
                              border-color: #ffecc7;
                            "
                            class="w-100"
                          >
                            <i
                              class="fa fa-exclamation-triangle text-warning"
                            ></i>
                            <b class="text-warning orderCode">
                              {{ orderCampainPhase }}
                            </b>
                          </b-alert>
                        </b-row>
                      </b-container>
                      <b-container>
                        <b-row
                          class="col-md-12 mb-1 m-0 p-0"
                          v-if="!userInfor.jobTitleId"
                        >
                          <b-alert
                            show
                            variant="danger"
                            style="
                              background-color: #ffffff;
                              border-color: #efefef;
                            "
                            class="w-100"
                          >
                            <i
                              class="fa fa-exclamation-triangle text-warning"
                            ></i>
                            <strong class="text-danger">
                              Tài khoản chưa được gán chức vụ, vui lòng liên hệ
                              admin để xử lí</strong
                            >
                          </b-alert>
                        </b-row>
                      </b-container>
                      <b-container class="bv-example-row">
                        <b-skeleton-wrapper :loading="!loadingComponent">
                          <b-row>
                            <b-col>
                              <OrderInfo
                                :data="orderInfo"
                                v-if="loadingComponent"
                                :action="action"
                              />
                            </b-col>
                            <b-col>
                              <CustomerInfo
                                v-if="loadingComponent"
                                :fromOrder="fromOrder"
                                :action="action"
                              />
                            </b-col>
                            <b-col>
                              <OrderNote
                                v-if="loadingComponent"
                                :action="action"
                              />
                            </b-col>
                            <b-col>
                              <OrderDiscount
                                v-if="loadingComponent"
                                :action="action"
                              />
                            </b-col>
                            <b-col>
                              <BillPayment
                                ref="bill-payment"
                                :finalAmount="totalAmount"
                                :billData="orderFinal"
                                :orderItems="orderItems"
                                :onSubmiting="false"
                                :fromOrder="fromOrder"
                                :subtractPointAmount="
                                  orderDiscount.subtractPointAmount
                                "
                                :action="action"
                                :isAllowQRCode="isAllowQRCode"
                                :canEditPaymentCode="canEditPaymentCode"
                                v-if="loadingComponent"
                                v-on:receive-payment="onReceivePayment"
                                v-on:receive-payment-mul="onReceivePaymentMul"
                                v-on:click-generate-qrcode="onClickGenerateQR"
                              />
                            </b-col>
                          </b-row>
                          <template #loading>
                            <b-row>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                              <b-col>
                                <div>
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                                <div class="mt-4">
                                  <b-skeleton width="50%"></b-skeleton>
                                  <b-skeleton></b-skeleton>
                                </div>
                              </b-col>
                            </b-row>
                          </template>
                        </b-skeleton-wrapper>
                        <!-- <b-row
                          class="col-md-12 m-0 p-0"
                          v-if="getInstallmentInterestZero && loadingComponent"
                        >
                          <b-alert
                            show
                            variant="warning"
                            style="
                              background-color: #fff3db;
                              border-color: #ffecc7;
                            "
                            class="w-100"
                          >
                            <i
                              class="fa fa-exclamation-triangle text-warning"
                            ></i>
                            <strong class="text-dark">
                              Chuyển sang cấu hình trả góp 0%</strong
                            >
                            <span
                              class="text-primary ml-2"
                              style="cursor: pointer"
                              @click="onShowInterestProgram"
                              >Xem chương trình</span
                            >
                          </b-alert>
                        </b-row> -->
                        <hr
                          class="hr-text"
                          data-content="Thông tin sản phẩm"
                          style="font-weight: 600"
                        />
                        <div class="mt-2" v-if="!onChangeProductTab">
                          <b-skeleton-wrapper :loading="!loadingComponent">
                            <template #loading>
                              <b-skeleton-table
                                :rows="5"
                                :columns="4"
                                :table-props="{ bordered: true, striped: true }"
                              ></b-skeleton-table>
                            </template>

                            <OrderProductsTable
                              :editable="true"
                              :otherParams="{
                                storeId: orderFinal.storeId,
                                customerMobile: orderFinal.customerMobile,
                              }"
                              v-if="loadingComponent"
                            />
                          </b-skeleton-wrapper>

                          <hr
                            class="hr-text"
                            data-content="Bút toán"
                            style="font-weight: 600"
                            v-if="orderId"
                          />

                          <OrderTransactions
                            :orderNumber="orderId"
                            v-if="orderId"
                          />
                          <div v-if="false">
                            <code class="mt-4 d-block">
                              {{ orderInfo ? Object.values(orderInfo) : [] }}
                            </code>
                            <code class="mt-4 d-block">
                              {{
                                orderCustomerInfo
                                  ? Object.values(orderCustomerInfo)
                                  : []
                              }}
                            </code>
                            <code class="mt-4 d-block">
                              {{
                                orderDiscount
                                  ? Object.values(orderDiscount)
                                  : []
                              }}
                            </code>
                            <code class="mt-4 d-block">
                              {{ orderNote ? Object.values(orderNote) : [] }}
                            </code>
                            <code class="mt-4 d-block">
                              {{ orderItems || [] }}
                            </code>
                          </div>
                        </div>
                      </b-container>
                    </div>
                    <!-- Step 2: Affiliate Information -->
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                    >
                      <b-container class="bv-example-row">
                        <b-skeleton-wrapper :loading="!loadingComponent">
                          <template #loading>
                            <b-skeleton-table
                              :rows="5"
                              :columns="3"
                              :table-props="{ bordered: true, striped: true }"
                            ></b-skeleton-table>
                          </template>
                          <OrderAffiliateTable
                            :items="orderAffiliateItems"
                            v-if="loadingComponent"
                          />
                        </b-skeleton-wrapper>
                      </b-container>
                    </div>
                    <!-- Step 3: Order Transaction -->
                    <!-- <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                      v-if="orderId"
                    >
                      <b-container class="bv-example-row">
                        <OrderTransactions :orderNumber="orderId" />
                      </b-container>
                    </div> -->
                    <!-- Step 4: History(EMPTY) -->
                    <!-- <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                      v-if="orderId"
                    >
                      <b-container class="bv-example-row">
                        <b-row></b-row>
                      </b-container>
                    </div> -->
                    <!-- Step 5: Upload File -->
                    <div
                      class="pb-5 full-width"
                      data-wizard-type="step-content"
                    >
                      <b-container fluid class="px-8">
                        <b-row>
                          <b-col>
                            <FileUploadManager
                              :entity-id="orderId"
                              :entity="'orders'"
                            />
                          </b-col>
                        </b-row>
                      </b-container>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <template #footer>
            <!-- <b-dropdown
              size="sm"
              split
              variant="primary"
              class="mr-3"
              @click="upsertOrder"
            >
              <template v-slot:button-content>
                <div class="font-weight-bolder" style="width: 4rem">
                  <span v-if="action === 'create'">Tạo mới</span
                  ><span v-else-if="action === 'update'">Cập nhật</span>
                </div>
              </template>
              <b-dropdown-item-button @click="onContinueCreateOrder"
                >Lưu và tiếp tục tạo đơn</b-dropdown-item-button
              >
            </b-dropdown> -->
            <b-button
              v-if="!preOrderId"
              class="font-weight-bolder mr-4"
              size="sm"
              variant="primary"
              style="width: 95px"
              @click="debounceUpsertOrder"
              :disabled="!loadingComponent || isSubmitting('save')"
            >
              <span v-if="action === 'create'">Tạo mới</span
              ><span v-else-if="action === 'update'">Cập nhật</span>
              <b-spinner
                small
                v-if="isSubmitting('save')"
                class="ml-1"
              ></b-spinner>
            </b-button
            >
            <b-button
              v-else
              class="font-weight-bolder mr-4"
              size="sm"
              variant="primary"
              style="width: 95px"
              @click="debounceUpsertOrder"
              :disabled="!loadingComponent || isSubmitting('save')"
            >
              <span>Tạo mới</span>
              <b-spinner
                small
                v-if="isSubmitting('save')"
                class="ml-1"
              ></b-spinner>
            </b-button
            >
            <b-button
              class="font-weight-bolder"
              size="sm"
              variant="secondary"
              style="width: 80px"
              :disabled="isSubmitting('save')"
              @click="onCloseOrder"
              >Huỷ</b-button
            >
          </template>
        </b-card>

        <QRCodeModal
          ref="qr-code-modal"
          :qrCode="qrCode"
          :billNumber="orderId"
          :type="REFERENCE_TYPE.ORDER"
          :transferAmount="transferAmount"
          :payment="qrCodePaymentInfo"
          @onGenerateQR="onGenerateQR"
          @afterGenerateQR="afterGenerateQR"
        />
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
      </template>
    </KTCodePreview>
    <ConfirmActionModal
      ref="order-conflict-modal"
      title="Đơn hàng đã thay đổi"
      message="Đơn hàng này vừa được cập nhật bởi một thao tác khác (thanh toán hoặc người dùng khác) trong lúc bạn đang chỉnh sửa. Bấm để tải lại dữ liệu mới nhất và chỉnh sửa lại."
      confirm-text="Tải lại dữ liệu"
      @confirm="reloadOnConflict"
    />
  </div>
</template>
<script>
import { REFERENCE_TYPE, WEBSITE_ORDER_SOURCE_IDS } from '@/utils/enum';
import KTCodePreview from '@/view/content/CodeTab.vue';
import KTWizard from '@/assets/js/components/wizard';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
// common import
import { validationMixin } from 'vuelidate';
import {
  apiCommonMixin,
  calculateMixin,
  commonMixin,
  linkMixin,
  swalMixin,
} from '@/view/mixins/';

// import component
import CustomerInfo from '@/view/components/customers/CustomerInfo';
import BillPayment from '@/view/components/bills/BillPayment';
import OrderInfo from '@/view/components/order/OrderInfo';
import OrderNote from '@/view/components/order/OrderNote';
import OrderDiscount from '@/view/components/order/OrderDiscount';
import OrderHeader from '@/view/components/order/OrderHeader';
import OrderProductsTable from '@/view/components/order/OrderProductsTable';
import OrderTransactions from '@/view/components/OrderTransactions.vue';
import QRCodeModal from '@/view/components/bills/QRCodeModal.vue';
import OrderAffiliateTable from '@/view/components/order/OrderAffiliateTable.vue';

import SaveDataUtil from '@/utils/saveDataToLocal';
import { mapGetters } from 'vuex';
import { EventBus } from '@/core/services/event-bus';
import debounce from 'debounce';

// setter vuex
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import {
  HANDLE_PURGE_ORDER_INFO,
  HANDLE_SET_ORDER_INFO,
} from '@/core/services/store/modules/order/order-info.module';
import {
  PURGE_CUSTOMER_ORDER_INFO,
  SET_CUSTOMER_ORDER_INFO,
} from '@/core/services/store/modules/order/order-customer-info.module';
import {
  PURGE_ORDER_DISCOUNT_INFO,
  SET_ORDER_DISCOUNT_INFO,
} from '@/core/services/store/modules/order/order-discount.module';
import {
  PURGE_ORDER_NOTE_INFO,
  SET_ORDER_NOTE_INFO,
} from '@/core/services/store/modules/order/order-note.module';
import {
  PURGE_PRODUCTS,
  SET_PRODUCTS,
} from '@/core/services/store/modules/order/order-product-table.module';
import {
  PURGE_INSTALLMENT_PROGRAM,
  PURGE_INSTALLMENT_SHINHAN,
  PURGE_INTEREST_SHINHAN,
  PURGE_INTEREST_ZERO,
  SET_INSTALLMENT_PROGRAM,
  SET_INSTALLMENT_SHINHAN,
  SET_INTEREST,
  SET_INTEREST_SHINHAN,
} from '@/core/services/store/modules/payment/payment-installment.module';
import {
  cloneDeep,
  convertPrice,
  getValueByKey,
  makeToastFaile,
  makeToastFailHtml,
  unMaskPrice,
} from '@/utils/common';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { ITEM_TYPE, ORDER_STATUS, PAYMENT_TYPE } from '@/utils/enum.js';
import { TIME_TRIGGER } from '@/utils/constants';
import Swal from 'sweetalert2';
import { deleteDoc, doc, onSnapshot } from '@firebase/firestore';
import db from '../../../firebase/init';
import { featureFlagMixin } from '@/view/mixins';
import submitLock from '@/view/mixins/submit-lock.mixins';
import FileUploadManager from '@/view/modules/upload/FileUploadManager.vue';
import ConfirmActionModal from '@/view/components/ConfirmActionModal.vue';
import {
  CUSTOMER_NAME_APPELLATION_WARNING_MESSAGE,
  hasCustomerNameAppellationPrefix,
} from '@/utils/validation';

export default {
  props: ['fromModal', 'orderIdFromModal'],
  mixins: [
    validationMixin,
    apiCommonMixin,
    linkMixin,
    calculateMixin,
    commonMixin,
    featureFlagMixin,
    swalMixin,
    submitLock,
  ],
  data() {
    return {
      orderUpdatedAt: null,
      qrCodePaymentInfo: {},
      isAllowQRCode: false,
      transferAmount: 0,
      REFERENCE_TYPE,
      originOrderSourceId: null,
      isLoading: false,
      fullPage: true,
      qrCode: {
        image: '',
        code: '',
      },
      isUsingQRCode: false,
      wizard: null,
      currentWizard: 1,
      orderId: null,
      preOrderId: null,
      orderInfo: {},
      orderNote: {},
      orderDiscount: {},
      orderCustomerInfo: {},
      orderPayment: {},
      onChangeProductTab: false,
      orderItems: [],
      loadingComponent: true,
      orderFinal: {
        storeId: null,
      },
      fromOrder: true,
      action: 'create',
      footSetting: {
        continue: false,
      },
      orderCampainPhase: null,
      customerInfo: {
        customerId: null,
        customerName: null,
      },
    };
  },
  validations: {},
  components: {
    KTCodePreview,
    CustomerInfo,
    BillPayment,
    OrderInfo,
    OrderNote,
    OrderDiscount,
    OrderHeader,
    OrderProductsTable,
    OrderTransactions,
    FileUploadManager,
    QRCodeModal,
    Loading,
    OrderAffiliateTable,
    ConfirmActionModal,
  },
  async created() {
    this.mappingEnum();
    this.resetParamsVuex();
    await this.getOrderIdFromAny();
  },
  async mounted() {
    if (!this.fromModal) {
      const title = !this.orderId ? 'Thêm mới đơn hàng' : 'Cập nhật đơn hàng';
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Đơn hàng', route: '/orders' },
        { title: 'Danh sách đơn hàng', route: '/orders' },
        { title: title },
      ]);
    }

    // const orderId = this.$route.params.id || null;

    this.wizard = new KTWizard('kt_wizard_v4_2', {
      startStep: this.currentWizard,
      clickableSteps: true,
    });

    this.$nextTick(function () {
      this.wizard.on('change', this.onChangeTab);
    });
    await this.getPaymentResult();
  },
  destroyed() {
    this.resetParamsVuex();
  },
  computed: {
    canEditPaymentCode() {
      const isWebsiteOrder = WEBSITE_ORDER_SOURCE_IDS.includes(
        Number(this.originOrderSourceId),
      );
      if (!isWebsiteOrder) {
        return true;
      }
      return SaveDataUtil.checkPermission('ORDER_UPDATE_REFERENCE_CODE');
    },
    ...mapGetters([
      'getProducts',
      'getOrderInfo',
      'getOrderCustomerInfo',
      'getOrderDiscount',
      'getOrderNote',
      'getInstallmentInterestZero',
      'getInstallmentProgram',
      'getInstallmentShinhan',
    ]),
    totalPriceItem() {
      let totalPrice = 0;
      this.orderItems.map((item) => {
        if (item.orderItemType === ITEM_TYPE.GIFT) {
          return;
        }
        if (item.orderItemType === ITEM_TYPE.ATTACH) {
          totalPrice += Number(item.repurchasePrice || 0) * Number(item.quantity || 0);
          return;
        }
        totalPrice += this.calculateTotalAmountOrderItems(item);
      });
      return totalPrice;
    },
    totalAmount() {
      let totalPrice = 0;
      this.orderItems.map((item) => {
        if (item.orderItemType === ITEM_TYPE.GIFT) {
          return;
        }
        if (item.orderItemType === ITEM_TYPE.ATTACH) {
          totalPrice += Number(item.repurchasePrice || 0) * Number(item.quantity || 0);
          return;
        }
        totalPrice += this.calculateTotalAmountOrderItems(item);
      });
      const discountAmount = unMaskPrice(this.orderDiscount.discountAmount);
      const discountType = this.orderDiscount.discountType;
      const customerShipFee = unMaskPrice(this.orderDiscount.customerShipFee);
      const shipFee = unMaskPrice(this.orderDiscount.shipFee);
      const subtractPointAmount = this.orderDiscount.subtractPointAmount;

      const discount = this.calculateDiscountAmount(
        discountAmount,
        discountType,
        totalPrice,
        1,
      );
      totalPrice =
        totalPrice -
        Number(discount) +
        Number(customerShipFee) +
        Number(shipFee) -
        Number(subtractPointAmount);

      return totalPrice;
    },
    totalPrice() {
      let total = 0;
      return total;
    },
    orderAffiliateItems() {
      return this.orderItems.filter(
        ({ rewardAffiliateId }) => rewardAffiliateId,
      );
    },
    isEnabledWarrantyRegistration() {
      return this.isFeatureActive('warranty-registration');
    },
    totalAmountBeforeDiscount() {
      let total = 0;
      for (let index = 0; index < this.orderItems.length; index++) {
        const element = this.orderItems[index];
        if (element.orderItemType !== ITEM_TYPE.GIFT) {
          const totalPriceItem = this.calculateTotalAmountOrderItems(element);
          total += totalPriceItem;
        }
        // if (element.billItemType === BILL_ITEM_TYPE.PRODUCT) {
        //   const totalPrice =
        //     unMaskPrice(element.price) * unMaskPrice(element.quantity);
        //   // Check discount type
        //   total += totalPrice;
        // } else if (
        //   element.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS &&
        //   element.checked === false
        // ) {
        //   total -=
        //     unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
        // } else if (
        //   element.billItemType === BILL_ITEM_TYPE.PRODUCT_PROMTION &&
        //   element.checked === true
        // ) {
        //   total +=
        //     unMaskPrice(element.returnPrice) * unMaskPrice(element.quantity);
        // }
      }
      return total;
    },
  },
  watch: {
    getOrderInfo: {
      handler(value) {
        this.orderInfo = value;
        //billpayment
        this.orderFinal.storeId = value.storeId;
      },
      deep: true,
    },
    getOrderCustomerInfo: {
      handler(value) {
        if (value) {
          this.orderCustomerInfo = value;
          // if (
          //   this.orderId &&
          //   value.customerId !== this.customerInfo.customerId
          // ) {
          //   this.orderCustomerInfo['customerId'] = this.customerInfo.customerId;
          // }
          // this.orderCustomerInfo = value;
          //billpayment
          this.orderFinal.customerMobile = value.customerMobile;
          this.orderFinal.customerName =
            value.customerName ?? this.customerInfo.customerName;
        }
      },
      deep: true,
    },
    getOrderDiscount: {
      handler(value) {
        if (value) {
          this.orderDiscount = value;
        }
      },
      deep: true,
    },
    getOrderNote: {
      handler(value) {
        if (value) {
          this.orderNote = value;
        }
      },
      deep: true,
    },
    getProducts: {
      handler(value) {
        if (value) {
          this.orderItems = value;
        }
      },
      deep: true,
    },
  },
  methods: {
    onClickGenerateQR(payment) {
      this.qrCodePaymentInfo = payment;
      if (payment.viaQRCode) {
        this.transferAmount = payment.paymentAmount;
        setTimeout(() => {
          this.$refs['qr-code-modal'].generateQRCode();
        }, TIME_TRIGGER);
      }
    },
    async getPaymentResult() {
      const VERIFY_COLLECTION = 'payment-verify-results';
      onSnapshot(doc(db, VERIFY_COLLECTION, String(this.orderId)), (snap) => {
        if (snap.exists()) {
          const snapData = snap.data();
          if (String(snapData.referenceNumber) === String(this.orderId)) {
            //  remove doc
            deleteDoc(doc(db, VERIFY_COLLECTION, String(this.orderId)));
            this.$refs['qr-code-modal'].hideModal();
            Swal.fire(
              'Thành công',
              'Bạn đã thanh toán thành công!',
              'success',
            ).then(() => {
              this.$router.go(this.$router.currentRoute);
            });
          }
        }
      });
    },
    onGenerateQR() {
      this.isLoading = true;
    },
    afterGenerateQR() {
      this.isLoading = false;
    },
    getOrderIdFromAny() {
      if (this.fromModal) {
        const orderId = this.orderIdFromModal || null;
        if (orderId) {
          this.orderId = this.orderIdFromModal;
        }
      } else {
        const orderId = this.$route.params.id || null;
        if (orderId) {
          this.orderId = orderId;
        }

        const preOrderIdFromUrl = this.$route.query.fromPreOrder || null;
        if (preOrderIdFromUrl) {
          this.preOrderId = preOrderIdFromUrl;
        }
      }

      if (this.orderId) {
        this.loadingComponent = false;
        this.action = 'update';
        this.isAllowQRCode = true;
        this.getOrder(this.orderId);
      }

      if (this.preOrderId) {
        this.loadingComponent = false;
        this.action = 'update';
        this.getPreOrderById();
      }
    },
    resetParamsVuex() {
      this.$store.dispatch(HANDLE_PURGE_ORDER_INFO);
      this.$store.dispatch(PURGE_ORDER_NOTE_INFO);
      this.$store.dispatch(PURGE_CUSTOMER_ORDER_INFO);
      this.$store.dispatch(PURGE_ORDER_DISCOUNT_INFO);
      this.$store.dispatch(PURGE_PRODUCTS);
      this.$store.dispatch(PURGE_INTEREST_ZERO);
      this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM);
      this.$store.dispatch(PURGE_INTEREST_SHINHAN);
      this.$store.dispatch(PURGE_INSTALLMENT_SHINHAN);
    },
    mappingEnum() {
      const userInfor = this.getEmployeeFromLocal();
      this.userInfor = userInfor;
    },
    getEmployeeFromLocal() {
      const userFromLocal = SaveDataUtil.getData('employee_info');
      if (userFromLocal) {
        const tmpInfo = JSON.parse(userFromLocal);
        return tmpInfo;
      }
    },
    onChangeTab(item) {
      const TAB = {
        INFO: 1,
        PRODUCT: 2,
      };
      if (item.currentStep === TAB.PRODUCT) {
        this.onChangeProductTab = true;
      } else if (item.currentStep === TAB.INFO) {
        this.onChangeProductTab = false;
      }
    },
    mappingOrderVuex(data) {
      const orderInfoVuex = this.getOrderInfo;
      const orderInfo = getValueByKey(orderInfoVuex, data);

      this.$store.dispatch(HANDLE_SET_ORDER_INFO, orderInfo);

      const orderNoteVuex = this.getOrderNote;
      const orderNote = getValueByKey(orderNoteVuex, data);
      this.$store.dispatch(SET_ORDER_NOTE_INFO, orderNote);

      const orderDiscountInfoVuex = this.getOrderDiscount;
      const orderDiscountInfo = getValueByKey(orderDiscountInfoVuex, data);
      this.$store.dispatch(SET_ORDER_DISCOUNT_INFO, orderDiscountInfo);

      const orderCustomerInfoVuex = this.getOrderCustomerInfo;
      const orderCustomerInfo = getValueByKey(orderCustomerInfoVuex, data);
      this.$store.dispatch(SET_CUSTOMER_ORDER_INFO, orderCustomerInfo);

      const orderItems = this.handleOrderItemGet(cloneDeep(data.orderItems));
      this.$store.dispatch(SET_PRODUCTS, orderItems);

      // Installment Interest
      this.$store.dispatch(SET_INTEREST, false);

      const installmentProgram = this.getInstallmentProgram;

      const installmentProgramInfor = getValueByKey(
        installmentProgram,
        data.installmentProgram
          ? {
              details: [],
              installmentProgramId: data.installmentProgram.id,
              installmentProgramName: data.installmentProgram.name,
              installmentProgramMonthNo: data.installmentProgramMonthNo,
              installmentProgramPrepayPercent:
                data.installmentProgramPrepayPercent,
              installmentProgramPrepayAmount:
                data.installmentProgramPrepayAmount || 0,
              prepayPercent: data.installmentProgram.prepayPercent,
              conversionFeePercent:
                data.installmentProgram.conversionFeePercent,
              conversionFeeMethod: data.installmentProgram.conversionFeeMethod,

              monthNo: data.installmentProgram.monthNo,
            }
          : {},
      );
      this.$store.dispatch(SET_INSTALLMENT_PROGRAM, installmentProgramInfor);

      // Installment Shinhan
      this.$store.dispatch(
        SET_INTEREST_SHINHAN,
        data.loanApplicationId ? true : false,
      );
      const installmentShinhan = this.getInstallmentShinhan;
      const intallmentShinhanInfor = getValueByKey(installmentShinhan, data);
      this.$store.dispatch(SET_INSTALLMENT_SHINHAN, intallmentShinhanInfor);

      this.orderFinal = data;
      this.transferAmount = this.orderFinal.transferAmount;

      setTimeout(() => {
        this.loadingComponent = true;
      }, TIME_TRIGGER);
    },
    debounceUpsertOrder: debounce(function() {
      this.upsertOrder();
    }, 300),
    calcPayments(payments, isInterestZero) {
      if (
        !isInterestZero &&
        payments.installments.length &&
        payments.installments[0].child
      ) {
        payments.installments[0].child.deleted = 1;
      }
      return payments;
    },
    calcPaymentsAmount(items) {
      return items.reduce((result, item) => {
        const unMask = unMaskPrice(item.paymentAmount) || 0;
        return result + Number(unMask);
      }, 0);
    },
    calcConversionFee(installments) {
      return installments.reduce((result, currentItem) => {
        if (currentItem.child && !currentItem.child.deleted) {
          result += currentItem.child.paymentAmount || 0;
        }
        return result;
      }, 0);
    },
    upsertOrder: function() {
      return this.withSubmitLock('save', async () => {
        const checkDate = this.orderNote.checkDate
          ? moment(this.orderNote.checkDate, 'DD/MM/YYYY').format(
              'YYYY-MM-DD',
            )
          : null;

        const paymentDate = this.orderDiscount.paymentDate
          ? moment(this.orderDiscount.paymentDate, 'DD/MM/YYYY').format(
              'YYYY-MM-DD',
            )
          : null;
        const orderItems = this.handleOrderItemUpsert(cloneDeep(this.orderItems));

        const discountAmount =
          unMaskPrice(this.orderDiscount.discountAmount) || 0;
        const customerShipFee =
          unMaskPrice(this.orderDiscount.customerShipFee) || 0;
        const shipFee = unMaskPrice(this.orderDiscount.shipFee) || 0;

        const isInterestZero = this.getInstallmentInterestZero ? 1 : 0;
        const intallmentProgram = this.getInstallmentProgram;
        const installmentShinhan = this.getInstallmentShinhan;

      const orderPayment = this.calcPayments(this.orderPayment, isInterestZero);
      const conversionFee = this.calcConversionFee(orderPayment.installments);
        const order = {
          id: this.orderId,
          ...this.orderInfo,
          ...this.orderNote,
          ...this.orderDiscount,
          checkDate: checkDate,
          ...this.orderCustomerInfo,
          customerWard:
            this.orderCustomerInfo.customerWard?.id ??
            this.orderCustomerInfo.customerWard,
          discountAmount: discountAmount,
          customerShipFee: customerShipFee,
          shipFee: shipFee,
          paymentDate: paymentDate,
          ...orderPayment,
          isInterestZero: isInterestZero,
          orderItems: orderItems,
          intallmentProgram: {
            ...intallmentProgram,
            installmentProgramPrepayAmount:
            unMaskPrice(intallmentProgram.installmentProgramPrepayAmount) || 0,
          },
          installmentShinhan,
          conversionFee,
          updatedAt: this.orderUpdatedAt,
        };

        const [isValid, messages] = this.validateUpsertOrder(order);

        if (!isValid) {
          makeToastFailHtml(this, messages);
          return;
        }

        if (hasCustomerNameAppellationPrefix(order.customerName)) {
          const result = await this.popupSwalWarning({
            title: 'Thông báo',
            text: CUSTOMER_NAME_APPELLATION_WARNING_MESSAGE,
          });

          if (!result.isConfirmed) {
            return;
          }
        }

        let method = null;
        if (this.preOrderId) {
          method = 'post';
        } else {
          method = this.action === 'update' ? 'put' : 'post';
        }

        return ApiService[method]('/orders/v2', order)
          .then((response) => {
            if (!this.orderId) {
              this.orderId = response.data.data;
            }
            if (this.fromModal) {
              this.$emit('refresh-order');
            } else {
              this.settingFooter();
            }
          })
          .catch((err) => {
            if (!err.response) {
              // network error
              makeToastFaile('Lỗi!');
            } else {
              const message = err.response.data.message;
              if ( typeof message === 'string' &&
                message.includes('ORDER_CONFLICT')
              ) {
                this.showOrderConflictModal();
              } else {
                makeToastFaile(message);
              }
            }
            this.$nprogress.done();
          });
      });
    },
    showOrderConflictModal() {
      this.$refs['order-conflict-modal'].show();
    },
    reloadOnConflict() {
      if (this.fromModal) {
        this.loadingComponent = false;
        this.getOrder(this.orderId);
      } else {
        window.location.reload();
      }
    },
    validateUpsertOrder(order) {
      let isValid = true;
      const messages = [];

      if (!order.storeId) {
        isValid = false;
        messages.push('Vui lòng chọn cửa hàng');
      }

      if (!order.orderSourceId) {
        isValid = false;
        messages.push('Vui lòng chọn nguồn đơn hàng');
      }

      if (!order.orderType) {
        isValid = false;
        messages.push('Vui lòng nhập loại đơn hàng');
      }

      if (!order.status) {
        isValid = false;
        messages.push('Vui lòng chọn trạng thái đơn hàng');
      }
      if (
        (order.checkDate && !order.checkTime) ||
        (!order.checkDate && order.checkTime)
      ) {
        isValid = false;
        messages.push('Vui lòng nhập cả ngày và giờ hoặc để trống cả hai!');
      }

      if (
        ORDER_STATUS.UN_SUCCESS === Number(order.status) &&
        !order.customerClassification
      ) {
        isValid = false;
        messages.push('Vui lòng chọn phân loại khách hàng');
      }

      if (
        [
          ORDER_STATUS.UN_SUCCESS,
          ORDER_STATUS.SYSTEM_CANCEL,
          ORDER_STATUS.CR_CANCEL,
        ].includes(Number(order.status)) &&
        !order.cancelStatus
      ) {
        isValid = false;
        messages.push('Vui lòng chọn lý do huỷ');
      }

      if (!order.orderItems.length) {
        isValid = false;
        messages.push('Vui lòng chọn sản phẩm');
      }

      if (!order.customerMobile) {
        isValid = false;
        messages.push('Vui lòng nhập số điện thoại khách hàng');
      }

      if (order.customerMobile && order.customerMobile.length > 12) {
        isValid = false;
        messages.push('Vui lòng nhập số điện thoại < 12 số');
      }

      if (!order.customerAppellation) {
        isValid = false;
        messages.push('Vui lòng nhập danh xưng khách hàng');
      }

      if (!order.customerName || !order.customerName.trim().length) {
        isValid = false;
        messages.push('Vui lòng nhập tên khách hàng');
      }

      if (order.discountAmount > this.totalPriceItem) {
        isValid = false;
        messages.push('Số tiền chiết khấu không nên cao hơn số tiền món hàng');
      }

      if (order.customerShipFee > 100000000) {
        isValid = false;
        messages.push('Phí vận chuyển thu của khách phải nhỏ hơn 100.000.000');
      }

      const isEnabledInsZeroMulProduct = this.isFeatureActive(
        'enabled-installment-zero-mul-product',
      );

      if (
        order.isInterestZero &&
        order.orderItems.length > 1 &&
        !isEnabledInsZeroMulProduct
      ) {
        isValid = false;
        messages.push('Chương trình trả góp 0% chỉ áp dụng cho 1 sản phẩm');
      }

      const errorPayments = this.validatePayment(order);

      if (errorPayments.length) {
        isValid = false;
        errorPayments.map((error) => {
          messages.push(error);
        });
      }

      return [isValid, messages];
    },
    validatePayment(billData) {
      const payments = [
        billData.cash,
        billData.transfer,
        billData.credits,
        billData.installments,
        billData.refunds,
      ];
      const errorMessages = payments.flat().reduce((result, item) => {
        if (item && item.paymentAmount > 0 && !item.paymentRefId) {
          result.push(
            `Tài khoản thanh toán số tiền ${convertPrice(
              item.paymentAmount,
            )} không hợp lệ`,
          );
        }
        return result;
      }, []);
      return errorMessages;
    },
    handleOrderItemGet(orderItems) {
      let term = [];
      const itemHandlers = orderItems.map((item) => {
        item.sellingPrice = item.productPrice;
        item.sellingPriceMask = item.productPrice;
        item.discountType = item.discountType || 1;
        item.comboItems = item.productInCombos || [];
        return item;
      });

      const mainItems = itemHandlers.filter(
        (item) => item.orderItemType === ITEM_TYPE.MAIN,
      );

      let count = 1;
      mainItems.map((parent) => {
        const relatedItems = itemHandlers.filter(
          (child) =>
            child.belongOrderDetailId === parent.orderItemId &&
            // Item con chỉ có thể là GIFT/ATTACH, không bao giờ là MAIN.
            // Guard này khớp với backend sortOrderItems(); chống đơn import
            // Excel cũ bị self-reference (belongOrderDetailId === id) làm nhân đôi.
            child.orderItemType !== ITEM_TYPE.MAIN,
        );
        const parentId = this.$uuid.v4();
        parent.id = parentId;
        parent.stt = count;
        term.push(parent);
        relatedItems.map((child) => {
          child.id = this.$uuid.v4();
          child.belongOrderDetailId = parentId;
          term.push(child);
        });
        count++;
      });
      return term;
    },
    getOrder: function(id) {
      ApiService.get(`/orders/${id}`).then((response) => {
          const { data } = response.data;
          const { status, message } = response.data;
          if (status) {
            this.orderUpdatedAt = data.updatedAt;
            this.orderCampainPhase = data.orderCampainPhase;
            this.originOrderSourceId = data.orderSourceId;
            this.customerInfo.customerId = data.customerId;
            this.customerInfo.customerName = data.customerName;
            this.mappingOrderVuex(data);
          } else {
            this.handleOrderNotAccessible(message);
          }
        })
        .catch((err) => {
          const message = err.response
            ? err.response.data && err.response.data.message
            : null;
          this.handleOrderNotAccessible(message);
        });
    },
    // Đơn không mở được (không tồn tại / bị ẩn) -> văng về danh sách, tránh kẹt skeleton.
    handleOrderNotAccessible(message) {
      makeToastFaile(message || 'Không tìm thấy đơn hàng');
      this.$nprogress.done();
      if (this.fromModal) {
        this.$emit('refresh-order');
        return;
      }
      this.$router.push({ name: 'list-order' });
    },

    getPreOrderById: async function() {
      ApiService.query(`pre-orders/${this.preOrderId}`).then(
        async (response) => {
          const { data } = response.data;
          const { status } = response.data;
          if (status) {
            if (data.orderId) {
              makeToastFaile(
                `Đơn hàng đặt trước đã được gắn với đơn hàng ${data.orderId}`,
              );
              this.preOrderId = null;
              this.$router.push({
                path: '/orders',
                query: {
                  id: data.orderId,
                },
              });
              return;
            }
            const product = data.product;

            data.orderItems = [];
            if (product) {
              product.productId = product.id;
              product.productPrice = product.sellingPrice;
              product.orderItemType = 1;
              product.quantity = 1;
              product.belongOrderDetailId = null;
              product.isPrivateNote = false;
              product.popPrivateNote = '';
              data.orderItems = [product];
            }
            data.orderSourceId = 756139;
            data.orderSourceName = 'Pre-Order';
            data.saleNote = data.notes ? data.notes : '';

            // TODO chỉnh lại cho pre -order
            data.installedMoneyAmount = data.installMoneyAmount || 0;
            data.installMoneyAccountId =
              Number(data.installMoneyAccountId) || null;
            data.installmentCode = data.installMoneyCode;
            data.installMoneyAccountName = data.installmentMoneyAccountName;
            data.preOrderId = this.preOrderId;
            data.status = 3;

            this.mappingOrderVuex(data);
          }
        },
      );
    },
    onReceivePayment(paymentInfo) {
      this.orderPayment = paymentInfo;
    },
    onReceivePaymentMul(items = [], type) {
      const payments = items.reduce((result, current) => {
        result.push({
          ...current,
          paymentAmount: unMaskPrice(current.paymentAmount) || 0,
        });
        return result;
      }, []);
      const sumAmount = (items) => {
        return items.reduce((result, item) => {
          return result + Number(item.paymentAmount);
        }, 0);
      };
      switch (type) {
        case PAYMENT_TYPE.INSTALLMENT: {
          this.orderPayment.installments = payments;
          this.orderPayment.installedMoneyAmount = sumAmount(payments);
          break;
        }
        case PAYMENT_TYPE.CREDIT: {
          this.orderPayment.credits = payments;
          this.orderPayment.creditAmount = sumAmount(payments);
          break;
        }
        case PAYMENT_TYPE.TRANSFER: {
          this.orderPayment.transfer = payments;
          this.orderPayment.transferAmount = sumAmount(payments);
          this.transferAmount = this.orderPayment.transferAmount;
          break;
        }
        case PAYMENT_TYPE.CASH: {
          this.orderPayment.cash = payments;
          this.orderPayment.depositAmount = sumAmount(payments);
          break;
        }
        case PAYMENT_TYPE.REFUND: {
          this.orderPayment.refunds = payments;
          this.orderPayment.refundAmount = sumAmount(payments);
          break;
        }
      }
    },
    onCloseOrder() {
      if (this.fromModal) {
        this.$bvModal.hide('md-edit-order');
      } else {
        this.$router.go(-1);
      }
    },
    onContinueCreateOrder() {
      this.footSetting.continue = true;
      this.upsertOrder();
    },
    settingFooter() {
      this.$router.push({
        path: '/orders',
      });
    },
    onShowInterestProgram() {
      this.$refs['bill-payment'].onLoading.interestZero = true;
      this.$nextTick(() => {
        EventBus.$emit('popup-insterest-program');
      });
    },
  },
};
</script>
<style lang="scss">
.upsert-order {
  .relative {
    position: relative;
  }
  #input-discount {
    padding-left: 35%;
    border: 1px solid #ced4da;
  }
  .absolute {
    top: 9px;
    left: 4%;
    font-size: 0.74vw;
    position: absolute;
  }

  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 2px;
  }

  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(15% - 0.25rem);
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    // background-color: #eef0f8;
    // border-radius: 4px 4px 0px 0px;
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .btn-config .btn {
    padding: 0.4rem 0.4rem;
  }
  .card-footer {
    padding: 1rem 2.25rem;
  }
  .form-group {
    margin-bottom: 1rem;
  }
}
</style>
<style>
.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
  overflow: scroll;
  max-height: 200px;
  position: absolute;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
  z-index: 10000001;
  font-weight: 500;
  background: white;
}

#autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  border-radius: 0.28rem;
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

.alert-warning {
  color: #855700;
  background-color: #ffeecc;
  border-color: #ffe7b8;
}
</style>
<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>
